<p-table [value]="matchingPeopleResult$ | async" [columns]="matchingPeopleResultCols" [paginator]="true" [alwaysShowPaginator]="false" [rows]="defaultTableRows" [(selection)]="selectedPeople" dataKey="PersonID" (onRowSelect)="onSelectPerson()" (onRowUnselect)="onUnselectPerson()" [autoLayout]="true" responsiveLayout="scroll">
  <ng-template pTemplate="caption">
    <div class="p-2 fw-bold text-center">Matching People Results</div>
    <p-messages key="findPeopleMsgs" [closable]="true"></p-messages>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="width: 3em" scope="col"><span class="visually-hidden">Select person row</span></th>
      <th *ngFor="let col of columns" scope="col" [pSortableColumn]="col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <td>
        <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
      </td>
      <td>
        <ng-container *ngFor="let fbiNum of rowData.ENESS_XREF_PeopleFBIFileNumbers">{{fbiNum.FBIFileNumber}}<br /></ng-container>
      </td>
      <td>
        <ng-container *ngFor="let stateNum of rowData.ENESS_XREF_PeopleStateIDNumbers">
          {{stateNum.StateAbbreviation?.concat(':')}} {{stateNum.StateIDNumbers}}<br />
        </ng-container>
      </td>
      <td>
        <button type="button" class="btn btn-sm btn-link" aria-label="{{'Person '+ rowData.LastName +' details'}}" tabindex="0" (click)="viewPersonDetails(rowData.PersonID)">{{ rowData.LastName }}</button>
      </td>
      <td>{{ rowData.FirstName }}</td>
      <td>{{ rowData.DateOfBirth | date:"MM/dd/yyyy"}}</td>
      <td>{{ rowData.SSN | ssnFormat}}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length + 1">
        No records found
      </td>
    </tr>
  </ng-template>
</p-table>
<aside>
  <p-sidebar (onHide)="onViewPersonDetailsClose()" [(visible)]="displaySidebar" position="right" styleClass="p-sidebar-lg" [showCloseIcon]="false">
    <ng-container *ngIf="showPersonDetails">
      <ng-container *ngIf="personDetails$ | async as personDetails">
        <ness-person-detail [personDTO]="personDetails" [isEventPersonForm]="false" [suppressEdit]="suppressEdit" (showPersonAddressDetail)="viewAddressDetails($event)"></ness-person-detail>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="showPersonAddressDetails">
      <ng-container *ngIf="personAddress">
        <ness-location-detail *ngIf="showLocationView" [addressDTO]="personAddress" [hasDeletePermission]="false" [hasEditPermission]="hasPermissionToEditAddress" [personAddressType]="personAddressType" [isFromPersonDetails]="true" (editLocationLocationClicked)="editLocation($event)"></ness-location-detail>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="showPersonAddressDetailForm">
      <ng-container *ngIf="personAddress">
        <ness-location-form *ngIf="showEditLocationView" [titleText]="'Edit location'" [isEventLocationForm]="false" [isEditForm]="true" [locationFormData]="personAddress" (associateLocation)="onLocationFormClose($event)" [isPersonAddressForm]="true" (closeForm)="onClickCloseButton()"></ness-location-form>
      </ng-container>
    </ng-container>
    <button type="button" (click)="onClickCloseButton()" class="btn btn-active m-3">Close</button>
  </p-sidebar>
</aside>
